<div class="layout-topbar">
    <div class="topbar-start">
        <button #menubutton type="button" class="topbar-menubutton p-link p-trigger" (click)="onMenuButtonClick()">
            <i class="pi pi-bars"></i>
        </button>

        <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb>
    </div>
    <div class="layout-topbar-menu-section" *ngIf="!isAccountFlow">
        <app-sidebar></app-sidebar>
    </div>

    <div class="topbar-end" style="z-index: 1100;">

        <ul class="topbar-menu  ">
            <!-- <li class="hidden lg:block">
                <div class="topbar-search" [ngClass]="{'topbar-search-active': searchActive}">
                    <button pButton icon="pi pi-search" class="topbar-searchbutton p-button-text p-button-secondary text-color-secondary p-button-rounded flex-shrink-0" type="button" (click)="activateSearch()"></button>
                    <div class="search-input-wrapper">
                        <span class="p-input-icon-right">
                            <input #searchinput type="text" pInputText placeholder="Search" (blur)="deactivateSearch()" (keydown.escape)="deactivateSearch()"/>
                            <i class="pi pi-search"></i>
                        </span>
                    </div>
                </div>
            </li>

            <li  class="profile-item topbar-item " >
                <button pButton type="button" icon="pi pi-bell" class="p-button-text p-button-secondary text-color-secondary p-button-rounded flex-shrink-0"></button>
            </li>

            <li  class="profile-item topbar-item " >
                <button pButton type="button" icon="pi pi-comment"  class="p-button-text p-button-secondary relative text-color-secondary p-button-rounded flex-shrink-0"></button>
            </li>

            <li class="ml-3">
                <button pButton type="button" icon="pi pi-cog" class="p-button-text p-button-secondary text-color-secondary p-button-rounded flex-shrink-0" (click)="onConfigButtonClick()"></button>
            </li> -->

            <!-- Current organization display -->
             @if(organizations.length > 0){
                <li class="topbar-item hidden md:flex align-items-center">
                    <div class="org-display-chip flex align-items-center gap-2 px-3 py-2 border-1 surface-border border-round-xl bg-white">
                        <span class="flex align-items-center justify-content-center w-2rem h-2rem border-circle border-1 surface-border bg-white text-800">
                            <i class="pi pi-building text-sm"></i>
                        </span>
                        <div class="flex flex-column">
                            <span class="font-semibold text-900 text-sm line-height-2 white-space-nowrap overflow-hidden text-overflow-ellipsis" style="max-width: 12rem;">{{currentSelectedOrg?.name || 'Organization'}}</span>
                        </div>
                    </div>
                </li>
                <!-- <p-dropdown
                    [pTooltip]="currentSelectedOrg ? 'Current Organization': 'Select an Organization'"
                    tooltipPosition="bottom"
                    [options]="organizations"
                    [ngModel]="currentSelectedOrg"
                    optionLabel="name"
                    placeholder="Select an Organization"
                    (onChange)="onOrganizationChange($event)">
                </p-dropdown> -->
             }

            <li #profile class="profile-item topbar-item " *ngIf="!isAccountFlow">
                <a pStyleClass="@next" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout" [hideOnOutsideClick]="true" pRipple class="cursor-pointer">
                    <p-avatar [label]="avatarLabel" shape="circle" severity="danger" [style]="{'background-color': '#873EFE', 'color': 'white'}"></p-avatar>
                </a>

                <ul class="topbar-menu active-topbar-menu p-4 w-15rem z-5 ng-hidden border-round" style="box-shadow: 0px 2px 6px rgba(0,0,0,0.2);">
                    <li role="menuitem" class="m-0 mb-3">
                        <a [routerLink]="['/settings/profile']" class="flex align-items-center hover:text-primary-500 transition-duration-200"
                        pStyleClass="@grandparent" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout">
                            <i class="pi pi-user pi-fw mr-2"></i>
                            <span >Profile</span>
                        </a>
                    </li>
                    <li role="menuitem" class="m-0 mb-3">
                        <a [routerLink]="['/org/settings']" class="flex align-items-center hover:text-primary-500 transition-duration-200"
                        pStyleClass="@grandparent" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout">
                            <i class="pi pi-cog mr-2"></i>
                            <span >Organization</span>
                        </a>
                    </li>
                    <li role="menuitem" class="m-0 mb-3">
                        <a [routerLink]="['/settings/manage/projects']" class="flex align-items-center hover:text-primary-500 transition-duration-200"
                        pStyleClass="@grandparent" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout">
                            <i class="fi fi-tr-diagram-project mr-2"></i>
                            <span >Projects</span>
                        </a>
                    </li>
                    @if(canAccessBilling){
                        <li role="menuitem" class="m-0 mb-3">
                            <a [routerLink]="['/billing/subscription']" class="flex align-items-center hover:text-primary-500 transition-duration-200"
                            pStyleClass="@grandparent" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout">
                                <i class="fi fi-tr-money-check mr-2"></i>
                                <span >Change Plan</span>
                            </a>
                        </li>
                    }
                    <!-- <li role="menuitem" class="m-0 mb-3">
                        <a [routerLink]="['/settings/usage']" class="flex align-items-center hover:text-primary-500 transition-duration-200"
                        pStyleClass="@grandparent" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout">
                            <i class="pi pi-wrench mr-2"></i>
                            <span >Usage</span>
                        </a>
                    </li> -->
                    <!-- <li class="layout-inline-menu-action-item">
                        <a [routerLink]="['/settings/organization']">
                            <i class="pi pi-cog pi-fw"></i>
                            <span >Organization</span>
                        </a>
                    </li> -->
                    <li role="menuitem" class="m-0">
                        <a (click)="onLogoutClicked()" class="flex align-items-center cursor-pointer hover:text-primary-500 transition-duration-200"
                        pStyleClass="@grandparent" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout">
                            <i class="pi pi-power-off pi-fw mr-2"></i>
                            <span>Logout</span>
                        </a>
                    </li>
                </ul>
            </li>

            <!-- <li class="right-panel-button relative hidden lg:block">
                <button pButton  type="button" label="Today" style="width:5.7rem" icon="pi pi-bookmark"
                class="layout-rightmenu-button hidden md:block font-normal" styleClass="font-normal" (click)="onSidebarButtonClick()"></button>
                <button pButton type="button" icon="pi pi-bookmark" styleClass="font-normal" class="layout-rightmenu-button block md:hidden" (click)="onSidebarButtonClick()"></button>
            </li> -->
        </ul>
    </div>
</div>
